export const LOGO_HEIGHT_MOBILE = 63;
export const LOGO_WIDTH_MOBILE = 100;
export const LOGO_HEIGHT = 74;
export const LOGO_WIDTH = 118;
